import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { useSupabase } from "@how/app-kit";
import type { UnavailableStaffChurch } from "./door-landing";

const rowSchema = z.object({
  tenant_id: z.string(),
  slug: z.string(),
  name: z.string(),
  reason: z.enum(["membership_suspended", "church_suspended", "church_unavailable"]),
});

/**
 * The signed-in login's own staff churches that cannot be opened, and why (my_unavailable_staff_churches; ADR 0068
 * R16, ruling P16). User-scoped (church-isolation.test.ts USER_SCOPED): it names only the person's own churches.
 */
export function useMyUnavailableStaffChurches(enabled = true) {
  const supabase = useSupabase();
  return useQuery({
    queryKey: ["my-unavailable-staff-churches"],
    enabled,
    queryFn: async (): Promise<UnavailableStaffChurch[]> => {
      const { data, error } = await supabase.rpc("my_unavailable_staff_churches");
      if (error) throw error;
      return z
        .array(rowSchema)
        .parse(data)
        .map((row) => ({
          tenantId: row.tenant_id,
          slug: row.slug,
          name: row.name,
          reason: row.reason,
        }));
    },
  });
}
